import config from '@config'
import usePageMetadata from '@hooks/usePageMetadata'
import { StandardTeaserAPIProps } from '@widgets/Teaser/standard/types'
import { RecommendationData } from '@widgets/Teaser/types'
import { isVideoRecommendationsEnabled } from '@widgets/Video/recommendations/utils'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { WidgetKind } from 'registry/utils'
export interface RecommendedItem extends StandardTeaserAPIProps {
  kind: WidgetKind
  aureusOfferId?: string
  recommendationData?: RecommendationData
  correlationId?: string
}

export interface RecomendationsQueryData {
  data: RecommendedItem[]
  'embedded-videos'?: RecommendedItem[]
}

export type NormalizedRecomendationsQueryData =
  Required<RecomendationsQueryData>

export type UseRecommendations = (arg?: {
  defaultData?: RecommendedItem[]
  forceDisable?: boolean
}) => NormalizedRecomendationsQueryData

const {
  recommendation: { apiUrl },
  publication: { publication },
} = config

const useRecommendations: UseRecommendations = ({
  defaultData,
  forceDisable,
} = {}) => {
  const [allData, setAllData] = useState<NormalizedRecomendationsQueryData>({
    data: defaultData ?? [],
    'embedded-videos': [],
  })
  const { id: articleId, hasVideo } = usePageMetadata()

  const hasVideoNormalized = !!hasVideo && isVideoRecommendationsEnabled()

  const { data: queryData } = useQuery<RecomendationsQueryData>(
    ['recommendations', articleId],
    async () =>
      (
        await fetch(
          `${apiUrl}/recommended-content/${articleId}/?pub=${publication}${
            hasVideoNormalized ? '&video=true' : ''
          }`,
          {
            credentials: 'include',
          }
        )
      ).json(),
    {
      enabled: !forceDisable && !!articleId,
    }
  )

  useEffect(() => {
    if (queryData) {
      const newAllData = {
        data: queryData.data ?? allData.data,
        'embedded-videos': queryData['embedded-videos'] ?? [],
      }
      setAllData(newAllData)
    }
  }, [allData.data, queryData])

  return allData
}

export { useRecommendations }
